
export const firebaseConfig = {
  apiKey: "AIzaSyBgKsSQ4aEl03lWqnIz_Vt0WpeCfusqO3Q",
  authDomain: "cheapgptchat.firebaseapp.com",
  projectId: "cheapgptchat",
  storageBucket: "cheapgptchat.firebasestorage.app",
  messagingSenderId: "347669405496",
  appId: "1:347669405496:web:187e598152942c48d62bcd",
  measurementId: "G-WH03W3PTEY"
};